// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seo-page-content[data-v-769e85ae]{order:1}.seo-page-content__title[data-v-769e85ae]{margin-bottom:var(--spaces-xl)}.seo-page-content__desc[data-v-769e85ae]{max-height:210px;padding-right:var(--padding-l);overflow-y:auto;color:var(--typography-title01)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
